<script setup>
import { validateEmail } from 'src/validations'
import sendForgotPasswordEmailMutation from 'src/graphql/sendForgotPasswordEmailMutation.gql'
import { useGlobalStore } from 'src/composables/useGlobalStore'
import { useMutation } from '@vue/apollo-composable'
import { useToast } from 'vue-toast-notification'
const $toast = useToast({ position: 'bottom' })

const { loginEmail, authModalVisible, authModalTab } = useGlobalStore()
const { mutate: sendForgotPasswordEmail, onError: onUpdateSendForgotPasswordEmailError } = useMutation(
  sendForgotPasswordEmailMutation,
  () => ({
    update: (cache, { data }) => {
      if (data.sendForgotPasswordEmail && data.sendForgotPasswordEmail.success) {
        $toast.open({ type: 'positive', message: 'Wir haben dir eine E-Mail mit einem Link geschickt, welcher dir erlaubt, ein neues Passwort zu definieren.', icon: 'fas fa-check-circle' })
      } else {
        $toast.open({ type: 'info', message: 'Hoppla - Hier ist etwas schiefgelaufen! Probiere es doch gleich nochmals oder melde dich bei den Raumpionieren, falls du weiterhin Probleme mit unserem Tool bekundest.', icon: 'fas fa-bell' })
      }
    }
  })
)
onUpdateSendForgotPasswordEmailError(error => {
  console.log('FORGOT PASSWORD ERROR', JSON.parse(JSON.stringify(error)))
  $toast.open({ type: 'info', message: error.message, icon: 'fas fa-bell' })
})

function sendEmail () {
  sendForgotPasswordEmail({ email: loginEmail.value })
  authModalVisible.value = false
}
</script>
<template lang="pug">
q-form.forgotten-password(@submit="sendEmail")
  .forgotten-password--container
    .forgotten-password--title Passwort vergessen
  .forgotten-password--wrapper
    .forgotten-password--subtitle Gib untenstehend deine Emailadresse ein und wir senden  umgehend ein neues Passwort an das entsprechende Profil.
    .forgotten-password--input-container
      q-input.forgotten-password--input(v-model="loginEmail" label-color="grey-14" hide-bottom-space autocomplete="E-mail address" label="E-mail" :rules="[validateEmail]")
  .forgotten-password--btn-container
    q-btn.forgotten-password--btn-send(type="submit" label="Passwort zusenden")
    q-btn.forgotten-password--btn-abort(@click="authModalTab = 'LOGIN'" label="Prozess abbrechen")
</template>
<style lang="sass">
.forgotten-password
  display: flex
  flex-direction: column
  min-height: 463px
  justify-content: space-between
  padding: 0 24px 24px 24px
  .forgotten-password--container
    display: flex
    flex-direction: column
    .forgotten-password--title
      font-size: 24px
      font-style: normal
      font-weight: 700
      color: white
  .forgotten-password--wrapper
    .forgotten-password--subtitle
      font-weight: 500
      font-size: 16px
      color: white
      margin-bottom: 10px
    .forgotten-password--input-container
      min-height: 80px
      display: flex
      flex-direction: column
      justify-content: space-between
      .forgotten-password--input
        .q-field__label
          color: #5FEFC0 !important
          font-size: 14px !important
          font-weight: 700
          line-height: 21px
        .q-field__native
          color: #9D9DD4
        .q-field__control:before
          border-color: #5C5C73
        .q-field__control:hover:before
          border-color: #757595
        .q-field__control:after
          background: #757595
        .q-field__control.text-negative::after
          background: #C10015 !important
  .forgotten-password--btn-container
    display: flex
    flex-direction: column
    .forgotten-password--btn-send, .forgotten-password--btn-abort
      padding: 12px 28px 12px 28px
      display: flex
      flex-direction: row
      justify-content: center
      align-items: center
      height: 28px
      width: 100%
      border-radius: 10px
      font-size: 16px
      font-weight: 600
      @media screen and (min-width: 1024px)
        font-size: 20px
    .forgotten-password--btn-send
      background: #5FEFC0
      color: #22223C
      margin-bottom: 16px
    .forgotten-password--btn-abort
      border: #5FEFC0 1px solid
      color: #5FEFC0
</style>
